import {
    data_Status_Line_ItemsActions,
    data_Status_Line_ItemsThunks as defaultThunks,
    data_Status_Line_ItemsSelectors as defaultSelectors,
    data_Status_Line_ItemsReducer,
} from './Data_Status_Line_Items-slice';
import * as thunks from './Data_Status_Line_Items-thunks';
import * as selectors from './Data_Status_Line_Items-selectors';

const data_Status_Line_ItemsThunks = { ...defaultThunks, ...thunks };
const data_Status_Line_ItemsSelectors = { ...defaultSelectors, ...selectors };

export {
    data_Status_Line_ItemsSelectors,
    data_Status_Line_ItemsActions,
    data_Status_Line_ItemsThunks,
    data_Status_Line_ItemsReducer,
};
